import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { ClienteSituacaoCadastrosFilterPipe } from '../pipes';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-cliente-situacao-multiselect',
    templateUrl: './cliente-situacao-multiselect.component.html',
    styleUrls: ['./cliente-situacao-multiselect.component.less'],
    providers: [
        ClienteSituacaoCadastrosFilterPipe
    ]
})
export class ClienteSituacaoMultiselectComponent implements OnInit, OnChanges {
    /** Situações dos clientes selecionados */
    @Input() situacoes: number[];
    /** Ao alterar a seleção das situações dos clientes */
    @Output() situacoesChange = new EventEmitter<number[]>();

    /** Cadastro de clientes para filtrar as situações */
    @Input() cadastros: number[] = [];

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Situação';
    @Input() checked = 'Situação';
    @Input() checkedPlural = 'Situações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhuma situação encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private clienteSituacaoCadastrosFilterPipe: ClienteSituacaoCadastrosFilterPipe) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-cliente-situacao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            // Ao alterar os cadastros para os filtros das situações, recriamos as opções do multiselect
            if (propName === 'cadastros' && !changes[propName].isFirstChange()) {
                this.create();
            }
        }
    }

    /** Cria as situações dos clientes para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        this.clienteSituacaoCadastrosFilterPipe.transform(this.cadastros).forEach(situacao => {
            selects.push({
                id: situacao.id,
                name: situacao.nome,
            });
        });
        this.options = selects;
    }

    /** Ao alterar a seleção das situações dos clientes */
    onChange() {
        this.situacoesChange.emit(this.situacoes);
    }
}
